import type { FPAItem } from '../../infra/protected/FPA/FPAItem';
import { findItemInTree } from './findItemInTree';

/**
 * `FinderContextTree` roots are folder-type rows when `parentItem` is null.
 * `pathSegmentContexts` from GetContextPath / search may start at a folder instance id,
 * so the first `updateData` key does not exist in the tree and expansion is a no-op.
 * This trims or prefixes ids so `revealPath` begins at a node that exists in `treeData`.
 */
export function alignRevealPathIdsForFinderTree(
  treeData: FPAItem[],
  pathIds: number[],
  folderTypeId?: number | null
): number[] {
  if (pathIds.length === 0 || treeData.length === 0) {
    return pathIds;
  }

  const rootIdSet = new Set(treeData.map((n) => +n.id));
  const firstRootIdx = pathIds.findIndex((id) => rootIdSet.has(+id));
  if (firstRootIdx >= 0) {
    return pathIds.slice(firstRootIdx);
  }

  if (folderTypeId != null && folderTypeId > 0 && rootIdSet.has(+folderTypeId)) {
    const rest = pathIds.filter((id) => +id !== +folderTypeId);
    return [folderTypeId, ...rest];
  }

  const firstPresentIdx = pathIds.findIndex((id) => findItemInTree(treeData, id) != null);
  if (firstPresentIdx > 0) {
    return pathIds.slice(firstPresentIdx);
  }

  return pathIds;
}
